/**
 * @packageDocumentation
 * @module f1/abstract-data-type
 */

import is_object from '../is/is_object';
import is_function from '../is/is_function';

export interface Size {
  /**
   * @public
   * @function f1.size
   * @param u the element to calculate size
   * @example
   *
   * ```ts
   * f1.size([16, 17, 18]) === 3,
   * f1.size({ g: 1, h: 1 }) === 2,
   * f1.size('123') === 3,
   * f1.size(false) === 1
   * f1.size(new Set([1, 2, 3, 4])) === 4
   * ```
   *
   */
  (u: unknown): number;
}

/**
 * @see Size
 */
export default (u: unknown): number => {
  return !is_object(u) ? 1 : 'length' in u ? u.length : is_function(u.size) ? u.size() : Object.keys(u).length;
};
